export const WaterBox = ({ width = '24', height = '24' }): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#363BC4"
      d="M10.056 4v.786a9 9 0 0 0-2.128.764c-.279.142-.513.361-.677.633A1.75 1.75 0 0 0 7 7.087v11.199c0 .454.176.89.488 1.212.313.321.737.502 1.179.502h6.666c.442 0 .866-.18 1.179-.502A1.74 1.74 0 0 0 17 18.286V7.087c0-.32-.087-.633-.25-.904a1.7 1.7 0 0 0-.678-.633 9 9 0 0 0-2.128-.764V4zm.555.571h2.778v.688a8.5 8.5 0 0 1 2.437.803c.186.095.342.241.451.422.11.181.168.39.167.603v1.484H7.556V7.087c0-.213.057-.422.167-.603.109-.181.265-.327.451-.421a8.5 8.5 0 0 1 2.437-.804zM7.556 9.143h8.888v5.714H7.556zm0 6.286h8.888v2.857a1.17 1.17 0 0 1-.325.808 1.1 1.1 0 0 1-.786.335H8.667a1.09 1.09 0 0 1-.786-.335 1.15 1.15 0 0 1-.325-.808z"
    />
  </svg>
);
